import $ from 'jquery';
import GoogleMapsLoader from 'google-maps';

export default class Map {
	constructor(options) {
		const defaults = {
			el: '.js-map',

			dom: {
				container: '.js-map-container'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		this.$container = this.$el.find(this.options.dom.container);
		return this;
	}

	initMap() {
		const stylez = [
			{
				featureType: 'all',
				elementType: 'all',
				stylers: [
					{saturation: -200}
				]
			}
		];

		GoogleMapsLoader.LIBRARIES = ['geometry', 'places'];
		GoogleMapsLoader.LANGUAGE = 'ru';
		GoogleMapsLoader.REGION = 'RU';
		GoogleMapsLoader.load(google => {
			const map = new google.maps.Map(this.$container[0], {
				center: {lat: 59.9380263, lng: 30.3227147},
				zoom: 16,
				mapTypeControlOptions: {
					mapTypeIds: [
						'tehgrayz',
						google.maps.MapTypeId.SATELLITE
					]
				},
				zoomControl: true,
				mapTypeControl: true,
				scaleControl: false,
				streetViewControl: true,
				rotateControl: false
			});
			new google.maps.Marker({ // eslint-disable-line no-new
				position: new google.maps.LatLng('59.9380263', '30.3227147'),
				map,
				title: 'ДЛТ',
				icon: {
					url: '/assets/images/map/marker_grey.png'
				}
			});

			const mapType = new google.maps.StyledMapType(stylez, {name: 'Карта'}); // eslint-disable-line no-new
			map.mapTypes.set('tehgrayz', mapType);
			map.setMapTypeId('tehgrayz');
		});
	}


	render() {
		if (this.$el.length) {
			this.getDom();
			this.initMap();
		}
		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/map/map.js
 **/